module.exports = "/_next/static/images/6f054644c272f40543ef067e97810bea-stapler@mobile320.jpg";